import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../contexts/UserContext'
import PublicHomePage from '../components/dashboards/PublicHomePage'

const HomePage = () => {
  const { user, isAuthenticated, isLoading } = useUser()
  const navigate = useNavigate()

  // Redirect logged-in users (avoid / → dashboard → verify-email loop)
  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      if (user.userType !== 'ADMIN' && !user.emailVerified) {
        navigate('/verify-email', { replace: true })
      } else {
        navigate('/dashboard', { replace: true })
      }
    }
  }, [isLoading, isAuthenticated, user, navigate])

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-500">Loading...</p>
        </div>
      </div>
    )
  }

  // Always show public homepage (buttons are hidden when logged in via PublicHomePage component)
  return <PublicHomePage />
}

export default HomePage 